import { Dispatch, SetStateAction } from 'react';

import {
  MostPreferredTourCategoriesViewModel,
  MostPreferredTourItemsViewModel,
  WishListItemViewModel,
  WishListViewModel,
} from '@api/v3';
import {
  tourMostPreferred,
  shipMostPreferred,
} from '@utils/newDataLayer/productMostPreferred';
import { generateUUID } from '@utils/generateUUID';

import { Item, DesktopItems } from './styled';
import FeaturedTourItem from './FeaturedTourItem';

type Props = {
  favoriteLists?: WishListViewModel[];
  refetchFavoriteLists?: any;
  defaultList?: WishListViewModel;
  defaultListItems?: WishListItemViewModel[];
  refetchDefaultList?: any;
  isRedirectingSet?: Dispatch<SetStateAction<boolean>>;
  formattedData: {
    categories: MostPreferredTourCategoriesViewModel[];
    activeCategoryItems: MostPreferredTourItemsViewModel[];
  };
};

const FeaturedTourDesktop = ({
  favoriteLists,
  refetchFavoriteLists,
  defaultList,
  defaultListItems,
  refetchDefaultList,
  isRedirectingSet,
  formattedData,
}: Props) => {
  return (
    <DesktopItems>
      {formattedData?.activeCategoryItems?.map((item, index) => {
        return (
          <Item
            key={generateUUID()}
            takeFullHeight={Boolean(index === 0)}
            onClick={() => {
              formattedData?.activeCategoryItems[0]?.category === 'Gemi'
                ? shipMostPreferred([item], true)
                : tourMostPreferred([item], true);
            }}
          >
            <FeaturedTourItem
              imageHeight={index === 0 ? '400px' : '137px'}
              image={item?.images?.[0]}
              title={item?.title ?? ''}
              days={item?.days ?? ''}
              price={item?.price}
              link={item?.url ?? ''}
              discount={item?.discount}
              tour={item}
              favoriteLists={favoriteLists}
              refetchFavoriteLists={refetchFavoriteLists}
              defaultList={defaultList}
              defaultListItems={defaultListItems}
              refetchDefaultList={refetchDefaultList}
              isRedirectingSet={isRedirectingSet}
            />
          </Item>
        );
      })}
    </DesktopItems>
  );
};

export default FeaturedTourDesktop;
